import React from 'react';
import { Box, Button, Link, Typography } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { CollectionInvoicePdf } from '../../clients/model';
import { apiAbsoluteUrl } from '../../clients/utils/pdf';

interface Props {
  pdf: CollectionInvoicePdf;
  applyTo: string;
  deletingPdfId: number | null;
  onDelete: (applyTo: string, pdfId: number, filename: string) => void;
}

const InvoicePdfCell: React.FC<Props> = ({ pdf, applyTo, deletingPdfId, onDelete }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      minWidth: 0,
      gap: 2,
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0, flex: 1, overflow: 'hidden' }}>
      <PictureAsPdfIcon sx={{ color: '#e53935', fontSize: 18, flexShrink: 0 }} />
      {pdf.download_url ? (
        <Link
          href={apiAbsoluteUrl(pdf.download_url)}
          download={pdf.filename}
          target="_blank"
          rel="noopener noreferrer"
          variant="body2"
          sx={{ wordBreak: 'break-all', minWidth: 0 }}
        >
          {pdf.filename}
        </Link>
      ) : (
        <Typography variant="body2" sx={{ wordBreak: 'break-all', minWidth: 0 }}>
          {pdf.filename}
        </Typography>
      )}
    </Box>
    {pdf.manual_import && (
      <Button
        size="small"
        variant="outlined"
        color="error"
        disabled={deletingPdfId === pdf.id}
        onClick={() => onDelete(applyTo, pdf.id, pdf.filename)}
        startIcon={<DeleteOutlineIcon />}
        sx={{ flexShrink: 0, borderWidth: 1, ml: 'auto' }}
      >
        {deletingPdfId === pdf.id ? 'Deleting…' : 'Delete'}
      </Button>
    )}
  </Box>
);

export default InvoicePdfCell;
